(function () {
  'use strict';

  angular
      .module('eltazkara.auth', [])

})();
